import {
    ANALYZE_OVERVIEW,
    INSPIRATION,
    DASHBOARD,
    SCHEDULER,
    SCHEDULER_COLLABORATION,
    SCHEDULER_COLLABORATION_SETTINGS,
    SCHEDULER_COLLABORATION_NOTIFICATIONS
} from '@/routes/privateRoutes';
import { SCHEDULER_QUERY_ACTION_PARAM } from '@/lib/scheduler/queryParams';
import { aclFeatures } from '@/lib/acl/aclFeatures';

//lib
import type { MainMenuType } from '@/lib/menu/main';

const mainMenuGroup: MainMenuType = [
    // Dashboard
    {
        icon: 'dashboard',
        name: 'commons:menu.dashboard',
        link: DASHBOARD
    },
    // Analytics
    {
        icon: 'analytics',
        link: ANALYZE_OVERVIEW,
        name: 'commons:menu.overview'
    },
    // Publishing
    {
        icon: 'publishing',
        name: 'commons:menu.publishing',
        quickAccess: {
            label: 'commons:menu.create_post',
            icon: 'plus',
            link: {
                pathname: SCHEDULER,
                query: {
                    [SCHEDULER_QUERY_ACTION_PARAM.NAME]:
                        SCHEDULER_QUERY_ACTION_PARAM.VALUES.CREATE_POST
                }
            }
        },
        subMenuItems: [
            {
                icon: 'publishing',
                link: SCHEDULER,
                name: 'commons:menu.calendar_view'
            },

            {
                icon: 'collaboration',
                link: SCHEDULER_COLLABORATION,
                name: 'commons:menu.collaboration',
                locked: aclFeatures.publishing.external_collaboration.read,
                urlActiveMenu: [
                    SCHEDULER_COLLABORATION_SETTINGS,
                    SCHEDULER_COLLABORATION_NOTIFICATIONS
                ],
                discoverId: 'post_approval'
            }
        ]
    },
    // Inspiration
    {
        icon: 'inspiration',
        link: INSPIRATION,
        name: 'commons:menu.inspiration'
    }
];

export default mainMenuGroup;
